
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/cookies",
      function () {
        return require("private-next-pages/about/cookies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/cookies"])
      });
    }
  